import { BASE_URL } from "apiUtil";

export const UPLOAD_ENDPOINT = BASE_URL + "/prod/api/upload";